const billingDateFormatter = new Intl.DateTimeFormat('en-GB', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});

/**
 * A billing timestamp as a calendar date, in the reader's own zone.
 *
 * One formatter for the whole page: the history table and the subscription
 * card show dates about the same account, and two formatters is how they end
 * up disagreeing. An unparseable value is returned as it came rather than
 * rendered as "Invalid Date", which tells the customer nothing.
 */
export function formatBillingDate(value: string): string {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }
  return billingDateFormatter.format(parsed);
}

/**
 * A provider's SCREAMING_SNAKE or lower_snake state as ordinary words.
 *
 * The last resort, for states no customer-facing mapping covers. A mapped
 * label is always better; this only exists so an unmapped one still reads as
 * language.
 */
export function formatProviderStatus(status: string): string {
  return status
    .split(/[\s_]+/)
    .filter(Boolean)
    .map(part => {
      const normalized = part.toLowerCase();
      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
    })
    .join(' ');
}
